import { useLayoutEffect } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MainContainer from "../../components/container/MainContainer";
import PageTitle from "../../components/titles/PageTitle";
import Loading from "../../components/loading/Loading";
import TextContainer from "../../components/text/TextContainer";
import Modal from "../../components/modal/Modal";
import { openModal } from "../../features/modalSLice";
import { useAuthorization } from "../../hooks/useAuthorization";
import DeleteUser from "./DeleteUser";
import { getUser } from "../../features/usersSlice";
import EditUser from "./EditUser";
import { ChevronLeft, FilePen, Trash2 } from "lucide-react";
import loadStatus from "../../util/loadStatus";
import NetworkError from "../error/NetworkError";

const SingleUser = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const { isAuthorized } = useAuthorization();
  const modalContent = useSelector((state) => state.modal.content);
  const mainUser = useSelector((state) => state.user.userInfo);
  const user = useSelector((state) => state.users.selected);
  const userLoading = useSelector((state) => state.users.load.getUser);

  const openEditUserModal = (edit, id) => {
    dispatch(openModal(<EditUser edit={edit} id={id} />));
  };

  const openDeleteUserModal = (id) => {
    dispatch(openModal(<DeleteUser id={id} />));
  };

  useLayoutEffect(() => {
    dispatch(getUser(id));
  }, []);

  if (userLoading === loadStatus.loading) {
    return <Loading />;
  }

  if (userLoading === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <MainContainer>
      <Modal>{modalContent}</Modal>
      {user.id && (
        <>
          <PageTitle
            title={`User - ${user.first_name}${
              user.other_names ? " " + user.other_names : ""
            } ${user.last_name}`}
          />
          <div className="bg-content  border border-bkg2 rounded-md p-7 mb-5 !text-text-1/55">
            <TextContainer
              label="Name"
              content={`${user.first_name}${
                user.other_names ? " " + user.other_names : ""
              } ${user.last_name}`}
            />

            <TextContainer label="Community" content={user.community} />
            <TextContainer label="Station" content={user.organization} />
            <TextContainer label="Country" content={user.country?.name} />
            <TextContainer
              label="Department"
              content={user.department || "N/A"}
            />

            <TextContainer label="Email" content={user.email || "N/A"} />
            <TextContainer label="Mobile" content={user.phone || "N/A"} />
            <TextContainer label="Phone" content={user.phone2 || "N/A"} />
            <TextContainer label="Role" content={user.role || "N/A"} />
            <TextContainer
              label="Province"
              content={user.province.name || "N/A"}
            />
          </div>
          <div className="p-4 border border-bkg2 rounded-md flex justify-between items-center">
            <Link to="/users" className="cancel-rss-btn">
              <ChevronLeft size={18} /> Back
            </Link>
            <div className="flex gap-3">
              <button
                onClick={(e) => openEditUserModal(true, id)}
                disabled={
                  !isAuthorized("users", "update") ||
                  (mainUser.role.toLowerCase() !== "super administrator" &&
                    user.role.toLowerCase() === "super administrator")
                }
                className="add-rss-btn"
              >
                <FilePen size={18} />
                Edit
              </button>
              <button
                onClick={(e) => openDeleteUserModal(id)}
                disabled={
                  !isAuthorized("users", "delete") ||
                  (mainUser.role.toLowerCase() !== "super administrator" &&
                    user.role.toLowerCase() === "super administrator")
                }
                className="delete-rss-btn"
              >
                <Trash2 size={18} />
                Delete
              </button>
            </div>
          </div>{" "}
        </>
      )}
    </MainContainer>
  );
};

export default SingleUser;
